"use client";

import { SafeHydrate } from "@/SafeHydrate";
import * as React from "react";
import { Quote } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
const testimonials = [{
  author: "Ihor S.",
  quote: "I contacted Eagle Exteriors and Joel was super helpful in scheduling the initial consultation and discussing my options. The crew that came out performed a fantastic job — the final product has my neighbors jealous.",
  position: "Homeowner in Maryland",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660464/img/badge_top_rated.png"
},, {
  author: "Stephanie M.",
  quote: "Joel’s industry knowledge helped us get complete coverage for our claim. His team worked quickly and efficiently, completing the job in one day to our HOA standards. We highly recommend Eagle Exteriors.",
  position: "Recent Roofing Customer",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660464/img/badge_top_rated.png"
}, {
  author: "Ed R.\xA0",
  quote: "\"I highly recommend Eagle Exteriors LLC for their professionalism, responsiveness, and quality workmanship.\"",
  position: "Homeowner in Maryland",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660464/img/badge_top_rated.png"
}];
export default function CreatorTestimonials() {
  return <section data-section-id="224046" id="what-our-clients-say" className="bg-background text-foreground py-24 relative overflow-hidden flex items-center justify-center min-h-[80vh]">
      {}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-primary/5 rounded-full blur-[120px] pointer-events-none" />
      <div className="absolute top-0 right-0 w-[400px] h-[400px] bg-primary/5 rounded-full blur-[100px] pointer-events-none" />

      <div className="container mx-auto px-4 md:px-16 relative z-10">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold font-default text-foreground mb-4">Real Stories From Local Homeowners</h2>
        </div>
        
        <Carousel opts={{
        align: "center",
        loop: true
      }} className="w-full max-w-5xl mx-auto">
          <CarouselContent>
            {testimonials.map((testimonial, i) => <CarouselItem key={i} data-index={i}>
                <div className="p-2 md:p-6">
                  <Card className="bg-white border-none rounded-[6px] shadow-xl overflow-hidden relative group">
                    {}
                    <div className="absolute top-0 left-0 w-full h-1 bg-primary opacity-100 transition-opacity duration-500" />
                    
                    <CardContent className="flex flex-col items-center text-center p-8 md:p-16 gap-8">
                      <div className="relative">
                        <div className="absolute -inset-4 bg-primary/10 rounded-full blur-xl opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                        <SafeHydrate><Avatar className="size-24 md:size-32 border-2 border-primary shadow-md relative z-10">
                          <AvatarImage src={testimonial.avatar} alt={testimonial.author} className="object-cover" />
                          <AvatarFallback className="bg-muted text-muted-foreground text-3xl font-bold font-default">
                            {testimonial.author.charAt(0)}
                          </AvatarFallback>
                        </Avatar></SafeHydrate>
                        <div className="absolute -bottom-4 -right-4 bg-white rounded-full p-2 border border-border/50 shadow-lg z-20 text-primary">
                          <Quote size={24} className="fill-current" />
                        </div>
                      </div>

                      <div className="flex gap-1">
                        {[...Array(5)].map((_, i) => <span key={i} className="text-primary text-xl"></span>)}
                      </div>

                      <blockquote className="text-lg md:text-xl italic font-default leading-relaxed text-secondary max-w-3xl">
                        "{testimonial.quote}"
                      </blockquote>

                      <div className="flex flex-col items-center gap-2 mt-4">
                        <span className="text-foreground font-bold font-default text-xl md:text-2xl tracking-tight">
                          {testimonial.author}
                          <p className="text-sm text-muted-foreground uppercase tracking-wide">
    {testimonial.position}
  </p>
                        </span>
                        
                      </div>
                    </CardContent>
                  </Card>
                </div>
              </CarouselItem>)}
          </CarouselContent>
          
          <div className="hidden md:block">
            <CarouselPrevious className="left-0 xl:-left-16 bg-foreground text-background border-none hover:bg-primary hover:text-foreground transition-all duration-300 size-14 rounded-none" />
            <CarouselNext className="right-0 xl:-right-16 bg-foreground text-background border-none hover:bg-primary hover:text-foreground transition-all duration-300 size-14 rounded-none" />
          </div>
          
          {}
          <div className="flex justify-center gap-4 mt-8 md:hidden">
            <CarouselPrevious className="static translate-y-0 translate-x-0 bg-foreground text-background border-none hover:bg-primary hover:text-foreground transition-all duration-300 size-14 rounded-none" />
            <CarouselNext className="static translate-y-0 translate-x-0 bg-foreground text-background border-none hover:bg-primary hover:text-foreground transition-all duration-300 size-14 rounded-none" />
          </div>
        </Carousel>
      </div>
    </section>;
}